
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { LoggerService } from './logging/logger.service';


@Injectable({
    providedIn: 'root'
})
export class ProfileService {

    constructor(
        private readonly http: HttpClient,
        private readonly logger: LoggerService
    ) { }

    saveProfile(firstName: string, lastName: string, email: string): Observable<any> {
        const postData = {
            firstName,
            lastName,
            email
        };

        const URL = `${environment.apiUrl}/users/current`;

        return this.http.put<any>(URL, postData)
            .pipe(
                // tap(data => console.log('server data:', data)), //will print data if needed here
                catchError(this.handleError('changePasswordRequest', URL))
            );
    }

    getProfile(): Observable<any> {
        const URL = `${environment.apiUrl}/users/current/`;

        return this.http.get(URL)
            .pipe(
                catchError(this.handleError('getProfile', URL))
            );
    }

    changePassword(oldPassword: string, newPassword: string): Observable<any> {
        const postData = {
            oldPassword,
            newPassword
        };
        const URL = `${environment.apiUrl}/users/current/changePassword`;

        return this.http.post<any>(URL, postData)
            .pipe(
                // tap(data => console.log('server data:', data)), //will print data if needed here
                catchError(this.handleError('changePasswordRequest', URL))
            );
    }

    getPasswordRequirements(): Observable<{ message: string }> {
        const URL = `${environment.apiUrl}/password/requirements`;

        return this.http.get<any>(URL)
            .pipe(
                // tap(data => console.log('server data:', data)), //will print data if needed here
                catchError(this.handleError('getPasswordRequirements', URL))
            );

    }

    validatePassword(password: string): Observable<{isValid: boolean, errors: string[]}> {
        const URL = `${environment.apiUrl}/password/validate`;

        return this.http.post<{isValid: boolean, errors: string[]}>(URL, { password })
            .pipe(
                catchError(this.handleError('validatePassword', URL))
            );
    }

    private handleError(operation: String, url: String): any {
        return (err: any) => {
            const errMsg = `error in ${operation}() retrieving ${url}`;
            this.logger.error(`${errMsg}:`, err);
            if (err instanceof HttpErrorResponse) {
                // you could extract more info about the error if you want, e.g.:
                // console.log(`status: ${err.status}, ${err.statusText}`);
            }
            return throwError(() => new Error(errMsg));
        };
    }
}
